(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // Set announcement bar height CSS variable for header positioning
  document.addEventListener('DOMContentLoaded', function() {
    const announcementBar = document.querySelector('[data-announcement-bar]');
    if (announcementBar) {
      const setAnnouncementBarHeight = () => {
        const height = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
      };
      
      // Set initial height
      setAnnouncementBarHeight();
      
      // Update on resize
      window.addEventListener('resize', setAnnouncementBarHeight);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Enhanced Apple-style interactions
  const interactiveElements = document.querySelectorAll('button, a, .group');
  
  interactiveElements.forEach(element => {
    element.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-2px)';
    });
    
    element.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
    
    element.addEventListener('mousedown', function() {
      this.style.transform = 'translateY(0) scale(0.98)';
    });
    
    element.addEventListener('mouseup', function() {
      this.style.transform = 'translateY(-2px) scale(1)';
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Form enhancements
  const commentForm = document.querySelector('.comment-form');
  if (commentForm) {
    const submitButton = commentForm.querySelector('button[type="submit"]');
    
    commentForm.addEventListener('submit', function() {
      if (submitButton) {
        submitButton.textContent = 'שולח תגובה...';
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }
    });
  }

  // Image lazy loading enhancement
  const images = document.querySelectorAll('img[loading="lazy"]');
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '50px'
  });

  images.forEach(img => {
    img.style.opacity = '0';
    img.style.transform = 'translateY(20px)';
    img.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    imageObserver.observe(img);
  });

  // Social share tracking (optional)
  const shareButtons = document.querySelectorAll('[href*="facebook.com"], [href*="twitter.com"]');
  shareButtons.forEach(button => {
    button.addEventListener('click', function() {
      const platform = this.href.includes('facebook') ? 'Facebook' : 'Twitter';
      console.log(`Article shared on ${platform}`);
      
      // Add subtle feedback animation
      this.style.transform = 'scale(0.95)';
      setTimeout(() => {
        this.style.transform = 'scale(1)';
      }, 150);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
// Enhanced Apple-style interactions for blog
document.addEventListener('DOMContentLoaded', function() {
  // Animate article cards on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Stagger the animation
        setTimeout(() => {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, index * 100);
      }
    });
  }, observerOptions);

  // Observe article cards
  const articleCards = document.querySelectorAll('article');
  articleCards.forEach((card, index) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(30px)';
    card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    card.style.transitionDelay = `${index * 0.1}s`;
    observer.observe(card);
  });

  // Enhanced button hover effects
  const buttons = document.querySelectorAll('a, button');
  buttons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      if (this.classList.contains('hover:scale-105') || this.classList.contains('hover:-translate-y-2')) {
        this.style.transform = 'translateY(-2px) scale(1.05)';
      }
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.transform = '';
    });
    
    button.addEventListener('mousedown', function() {
      this.style.transform = 'translateY(0) scale(0.98)';
    });
    
    button.addEventListener('mouseup', function() {
      this.style.transform = 'translateY(-2px) scale(1.05)';
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // Add ripple effect to article cards
  articleCards.forEach(card => {
    card.addEventListener('click', function(e) {
      // Only add ripple if clicking the card itself, not links
      if (e.target === this || e.target.tagName === 'IMG') {
        const ripple = document.createElement('div');
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.cssText = `
          position: absolute;
          border-radius: 50%;
          background: rgba(219, 177, 134, 0.3);
          transform: scale(0);
          left: ${x}px;
          top: ${y}px;
          width: ${size}px;
          height: ${size}px;
          pointer-events: none;
          animation: ripple 0.6s ease-out;
        `;
        
        this.style.position = 'relative';
        this.style.overflow = 'hidden';
        this.appendChild(ripple);
        
        setTimeout(() => ripple.remove(), 600);
      }
    });
  });
});

// Add CSS for ripple animation
const style = document.createElement('style');
style.textContent = `
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  function toggleFAQ(button) {
    const faqItem = button.closest('.faq-item');
    if (!faqItem) return;
    
    const answer = faqItem.querySelector('.faq-answer');
    const icon = faqItem.querySelector('.faq-icon');
    if (!answer || !icon) return;
    
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Close all other FAQ items
    document.querySelectorAll('.faq-item').forEach(item => {
      if (item !== faqItem) {
        const otherQuestion = item.querySelector('.faq-question');
        const otherAnswer = item.querySelector('.faq-answer');
        const otherIcon = item.querySelector('.faq-icon');
        if (otherQuestion && otherAnswer && otherIcon) {
          otherQuestion.setAttribute('aria-expanded', 'false');
          otherAnswer.classList.add('hidden');
          otherIcon.style.transform = 'rotate(0deg)';
        }
      }
    });
    
    // Toggle current FAQ item
    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      answer.classList.add('hidden');
      icon.style.transform = 'rotate(0deg)';
    } else {
      button.setAttribute('aria-expanded', 'true');
      answer.classList.remove('hidden');
      icon.style.transform = 'rotate(180deg)';
    }
  }
  
  // Use event delegation on document
  document.addEventListener('click', function(e) {
    const faqQuestion = e.target.closest('.faq-question');
    if (faqQuestion) {
      e.preventDefault();
      e.stopPropagation();
      toggleFAQ(faqQuestion);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function toggleMobileMenu() {
    const mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenu) {
      const isHidden = mobileMenu.style.display === 'none';
      mobileMenu.style.display = isHidden ? 'block' : 'none';
      console.log('Mobile menu toggled:', isHidden ? 'visible' : 'hidden');
    } else {
      console.error('Mobile menu element not found');
    }
  }

  // Smooth scrolling functionality
  document.addEventListener('DOMContentLoaded', function() {
    // Add smooth scrolling to all navigation links
    const smoothScrollLinks = document.querySelectorAll('.smooth-scroll');
    
    smoothScrollLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          // Close mobile menu if open
          const mobileMenu = document.getElementById('mobile-menu');
          if (mobileMenu && mobileMenu.style.display !== 'none') {
            mobileMenu.style.display = 'none';
          }
          
          // Smooth scroll to target element
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Wait for Swiper to be available
  function initHowToUseSwiper() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initHowToUseSwiper, 100);
      return;
    }
    
    const howToUseSwiper = new Swiper('.how-to-use-swiper', {
      // Swiper configuration
      slidesPerView: 1,
      // slidesPerView: 'auto',
      spaceBetween: 30,
      centeredSlides: true,
      rewind: false,
      loop: false,
      // watchOverflow: true,
      grabCursor: true,
      slideToClickedSlide: true,
      slidesPerGroup: 1,
      dir: 'rtl', // Use RTL direction for swiper to match site
      
      // Responsive breakpoints - keep single slide view for proper navigation
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 5,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      
      // Navigation arrows - disabled since we're using custom buttons
      navigation: false,
      
      // Pagination
      pagination: {
        el: '.how-to-use-swiper .swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },
      
      // Touch/swipe settings
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      
      // Smooth transitions
      speed: 600,
      effect: 'slide',
      
      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'השקף הקודם',
        nextSlideMessage: 'השקף הבא',
        firstSlideMessage: 'זהו השקף הראשון',
        lastSlideMessage: 'זהו השקף האחרון',
      },
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      
      // Mouse wheel control
      mousewheel: {
        enabled: false,
      },
      
      // Event callbacks for future video integration
      on: {
        slideChange: function () {
          console.log('Slide changed to:', this.activeIndex);
          // Future: Pause previous video, prepare next video
        },
        
        slideChangeTransitionEnd: function () {
          console.log('Slide transition ended');
          // Future: Start video playback if auto-play is enabled
        },
        
        // Future: Auto-advance when video ends
        init: function() {
          console.log('How to Use Swiper initialized');
          // Future: Set up video event listeners
        }
      }
    });
    
    // Get custom navigation buttons
    const prevBtn = document.querySelector('.how-to-use-prev-btn');
    const nextBtn = document.querySelector('.how-to-use-next-btn');
    
    // Function to update button states
    function updateButtonStates() {
      if (howToUseSwiper.isBeginning && !howToUseSwiper.params.loop) {
        prevBtn.classList.add('disabled');
      } else {
        prevBtn.classList.remove('disabled');
      }
      
      if (howToUseSwiper.isEnd && !howToUseSwiper.params.loop) {
        nextBtn.classList.add('disabled');
      } else {
        nextBtn.classList.remove('disabled');
      }
    }
    
    // Add click event listeners to custom buttons
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function() {
        console.log('Previous button clicked, current index:', howToUseSwiper.activeIndex);
        if (!this.classList.contains('disabled')) {
          howToUseSwiper.slidePrev();
          console.log('After slidePrev, new index:', howToUseSwiper.activeIndex);
        }
      });
      
      nextBtn.addEventListener('click', function() {
        console.log('Next button clicked, current index:', howToUseSwiper.activeIndex);
        if (!this.classList.contains('disabled')) {
          howToUseSwiper.slideNext();
          console.log('After slideNext, new index:', howToUseSwiper.activeIndex);
        }
      });
      
      // Update button states on slide change
      howToUseSwiper.on('slideChange', updateButtonStates);
      howToUseSwiper.on('reachEnd', updateButtonStates);
      howToUseSwiper.on('reachBeginning', updateButtonStates);
      
      // Initial button state
      updateButtonStates();
    }
    
    // Expose swiper instance for external control
    window.howToUseSwiper = howToUseSwiper;
    
    // Future: Video integration functions
    window.howToUseVideoIntegration = {
      playVideo: function(slideIndex) {
        // Future implementation for video playback
        console.log('Future: Play video in slide', slideIndex);
      },
      
      pauseVideo: function(slideIndex) {
        // Future implementation for video pause
        console.log('Future: Pause video in slide', slideIndex);
      },
      
      onVideoEnd: function(slideIndex) {
        // Future implementation for auto-advance on video end
        console.log('Future: Video ended in slide', slideIndex);
        if (howToUseSwiper && !howToUseSwiper.destroyed) {
          howToUseSwiper.slideNext();
        }
      }
    };
  }
  
  // Initialize swiper
  initHowToUseSwiper();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lora-product-add-to-cart"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, initializing product gallery...');
    
    // Product Gallery State
    let currentColor = 'white';
    let currentImageIndex = 0;
    
    // Gallery Elements
    const mainImage = document.getElementById('product-main-image');
    const thumbnailContainer = document.getElementById('gallery-thumbnails');
    const mobileThumbnails = document.getElementById('mobile-thumbnails');
    const prevBtn = document.getElementById('prev-image');
    const nextBtn = document.getElementById('next-image');
    const mainImageContainer = document.getElementById('main-image-container');
    
    // Color selection elements
    const colorOptions = document.querySelectorAll('.color-option');
    const selectedColorName = document.getElementById('selected-color-name');
    
    // Price elements
    const currentPriceElement = document.getElementById('current-price');
    const originalPriceElement = document.getElementById('original-price');
    const discountAmount = window.discountAmountILS || 0;
    
    // Format price in ILS
    function formatPrice(priceInCents) {
      const price = priceInCents / 100;
      return `${price.toLocaleString('he-IL')} ₪`;
    }
    
    // Update price display based on selected color
    function updatePriceDisplay(colorOption) {
      const variantPrice = parseInt(colorOption.dataset.price, 10);
      if (variantPrice && currentPriceElement) {
        if (originalPriceElement && discountAmount > 0) {
          currentPriceElement.textContent = formatPrice(variantPrice - (discountAmount * 100));
          currentPriceElement.dataset.price = variantPrice - (discountAmount * 100);

          originalPriceElement.textContent = formatPrice(variantPrice);
          originalPriceElement.dataset.price = variantPrice;
        }
        else {
          currentPriceElement.textContent = formatPrice(variantPrice);
          currentPriceElement.dataset.price = variantPrice;
          if (originalPriceElement) {
            originalPriceElement.textContent = '';
          }
        }
      }
    }
    
    // Initialize gallery
    function initGallery() {
      updateGalleryForColor(currentColor);
      setupEventListeners();
    }
    
    // Update gallery when color changes
    function updateGalleryForColor(color) {
      currentColor = color;
      currentImageIndex = 0;
      const images = window.productGallery[color] || window.productGallery.white;
      
      
      // Generate thumbnails
      generateThumbnails(images);
      
      // Update main image
      updateMainImage();
    }
    
    // Generate thumbnail elements
    function generateThumbnails(images) {
      // Desktop thumbnails
      thumbnailContainer.innerHTML = '';
      
      // Mobile thumbnails  
      mobileThumbnails.innerHTML = '';
      
      images.forEach((image, index) => {
        // Desktop thumbnail
        const thumbElement = createThumbnailElement(image, index, false);
        thumbnailContainer.appendChild(thumbElement);
        
        // Mobile thumbnail
        const mobileThumbElement = createThumbnailElement(image, index, true);
        mobileThumbnails.appendChild(mobileThumbElement);
      });
    }
    
    // Create individual thumbnail element
    function createThumbnailElement(image, index, isMobile) {
      const thumbDiv = document.createElement('div');
      thumbDiv.className = `thumbnail ${index === 0 ? 'active' : ''} ${isMobile ? 'mobile-thumb' : 'desktop-thumb'}`;
      thumbDiv.style.cssText = `
        cursor: pointer;
        border-radius: 12px;
        overflow: hidden;
        background: white;
        transition: all 0.3s ease;
        box-sizing: content-box;
        ${isMobile ? 'min-width: 60px; height: 60px;' : 'aspect-ratio: 4/3;'}
      `;
      
      const thumbImg = document.createElement('img');
      thumbImg.src = image.src;
      thumbImg.alt = image.alt;
      thumbImg.className = 'w-full h-full object-contain';
      thumbImg.loading = 'lazy';
      
      thumbDiv.appendChild(thumbImg);
      
      // Click handler
      thumbDiv.addEventListener('click', () => {
        currentImageIndex = index;
        updateMainImage();
        updateThumbnailStates();
      });
      
      // Hover effects
      thumbDiv.addEventListener('mouseenter', () => {
        if (index !== currentImageIndex) {
          thumbDiv.style.borderColor = '#DBB186';
          thumbDiv.style.opacity = '0.8';
        }
      });
      
      thumbDiv.addEventListener('mouseleave', () => {
        if (index !== currentImageIndex) {
          thumbDiv.style.borderColor = 'transparent';
          thumbDiv.style.opacity = '1';
        }
      });
      
      return thumbDiv;
    }
    
    // Update main image display
    function updateMainImage() {
      const images = window.productGallery[currentColor] || window.productGallery.white;
      const currentImage = images[currentImageIndex];
      
      if (currentImage && mainImage) {
        // Fade effect
        mainImage.style.opacity = '0';
        
        setTimeout(() => {
          mainImage.src = currentImage.src;
          mainImage.alt = currentImage.alt;
          mainImage.dataset.imageIndex = currentImageIndex;
          mainImage.style.opacity = '1';
          
          // Update thumbnail states
          updateThumbnailStates();
        }, 150);
      }
    }
    
    // Update thumbnail active states
    function updateThumbnailStates() {
      const allThumbnails = document.querySelectorAll('.thumbnail');
      allThumbnails.forEach((thumb, index) => {
        if (index === currentImageIndex) {
          thumb.classList.add('active');
          thumb.style.borderColor = '#DBB186';
        } else {
          thumb.classList.remove('active');
          thumb.style.borderColor = 'transparent';
        }
      });
    }
    
    // Navigation functions
    function navigateToImage(direction) {
      const images = window.productGallery[currentColor] || window.productGallery.white;
      const maxIndex = images.length - 1;
      
      if (direction === 'next') {
        currentImageIndex = currentImageIndex >= maxIndex ? 0 : currentImageIndex + 1;
      } else {
        currentImageIndex = currentImageIndex <= 0 ? maxIndex : currentImageIndex - 1;
      }
      
      updateMainImage();
    }
    
    // Setup all event listeners
    function setupEventListeners() {
      // Navigation buttons
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          navigateToImage('prev');
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          navigateToImage('next');
        });
      }
      
      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          navigateToImage('prev');
        } else if (e.key === 'ArrowRight') {
          navigateToImage('next');
        }
      });
      
    }
    
    // Function to update stock indicator based on selected color
    function updateStockIndicator(color) {
      const stockIndicator = document.getElementById('stock-indicator');
      const checkoutBtn = document.querySelector('.hero-checkout-btn');
      if (!stockIndicator || !window.variantInventory || !window.stockTranslations) return;
      
      const inventory = window.variantInventory[color];
      if (!inventory) return;
      
      const quantity = inventory.quantity;
      const available = inventory.available;
      
      let html = '';
      
      if (quantity > 0 && quantity <= 5) {
        // Low stock warning - red if <=3, amber if 4-5
        const lowStockText = window.stockTranslations.lowStock.replace('__COUNT__', quantity);
        const colorClass = quantity <= 3 ? 'red' : 'amber';
        html = `
          <svg class="w-4 h-4 text-${colorClass}-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
          </svg>
          <span class="text-sm text-${colorClass}-600 font-medium" data-stock-quantity="${quantity}">${lowStockText}</span>
        `;
        // Enable button for low stock (still available)
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
        }
      } else if (available) {
        // In stock
        html = `
          <svg class="w-4 h-4 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
          </svg>
          <span class="text-sm text-emerald-600 font-medium">${window.stockTranslations.inStock}</span>
        `;
        // Enable button for in stock
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
        }
      } else {
        // Out of stock
        html = `
          <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"/>
          </svg>
          <span class="text-sm text-red-600 font-medium">${window.stockTranslations.outOfStock}</span>
        `;
        // Disable button for out of stock
        if (checkoutBtn) {
          checkoutBtn.disabled = true;
        }
      }
      
      stockIndicator.innerHTML = html;
    }
    
    // Color selection functionality (enhanced)
    colorOptions.forEach(option => {
      option.addEventListener('click', function() {
        const color = this.dataset.color;
        const colorName = this.dataset.name;
        
        // Remove active class from all options
        colorOptions.forEach(opt => {
          opt.classList.remove('active', 'ring-2', 'ring-primary', 'ring-offset-2');
        });
        
        // Add active class to clicked option
        this.classList.add('active', 'ring-2', 'ring-primary', 'ring-offset-2');
        
        // Update color name
        if (selectedColorName && colorName) {
          selectedColorName.textContent = colorName;
        }
        
        // Update price display for new color
        updatePriceDisplay(this);
        
        // Update gallery for new color
        updateGalleryForColor(color);
        
        // Update stock indicator for new color
        updateStockIndicator(color);
        
        // Animation feedback
        this.style.transform = 'scale(0.95)';
        setTimeout(() => {
          this.style.transform = '';
        }, 150);
      });
    });

    // Helper functions for external use
    window.changeProductColor = function(color) {
      const targetOption = document.querySelector(`.color-option[data-color="${color}"]`);
      if (targetOption) {
        targetOption.click();
      }
    };
    
    window.navigateGallery = function(direction) {
      navigateToImage(direction);
    };
    
    // Initialize the gallery
    initGallery();

    // Quantity Selector Functionality
    const quantityDisplay = document.getElementById('product-quantity');
    const decreaseBtn = document.getElementById('quantity-decrease');
    const increaseBtn = document.getElementById('quantity-increase');
    
    if (quantityDisplay && decreaseBtn && increaseBtn) {
      let quantity = 1;
      const minQty = 1;
      const maxQty = 10;
      
      // Decrease quantity
      decreaseBtn.addEventListener('click', function() {
        if (quantity > minQty) {
          quantity--;
          quantityDisplay.textContent = quantity;
        }
      });
      
      // Increase quantity
      increaseBtn.addEventListener('click', function() {
        if (quantity < maxQty) {
          quantity++;
          quantityDisplay.textContent = quantity;
        }
      });
      
      // Helper function to get current quantity
      window.getProductQuantity = function() {
        return quantity;
      };
    }

    // Variant ID mapping for different colors
    const variantMap = {
      'white': '51243180228921',
      'black': '51243180163385',
      'pink': '51243180196153'
    };
    
    // Get currently selected color
    function getSelectedVariantId() {
      const activeColor = document.querySelector('.color-option.active');
      const color = activeColor ? activeColor.dataset.color : 'white'; // Default to white
      return variantMap[color] || variantMap['white'];
    }

    // Function to clear cart, add item, and go to checkout
    async function buyNowCheckout(variantId, button) {
      try {
        // Disable button and show loading
        const originalText = button.innerHTML;
        button.disabled = true;
        button.style.opacity = '0.7';
        
        // Get quantity from the quantity selector
        const quantity = window.getProductQuantity ? window.getProductQuantity() : 1;
        
        // First, clear the entire cart
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        // Then add the selected item to the now-empty cart with the specified quantity
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity
            }]
          })
        });

        if (response.ok) {
          // Successfully added to cart, now redirect to checkout
          // Include discount code if one was provided via URL parameter
          let checkoutUrl = '/checkout';
          if (window.couponData && window.couponData.hasDiscount && window.couponData.discountCode) {
            checkoutUrl = '/checkout?discount=' + encodeURIComponent(window.couponData.discountCode);
          }
          window.location.href = checkoutUrl;
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('אירעה שגיאה. אנא נסה שוב.');
        button.disabled = false;
        button.style.opacity = '1';
      }
    }

    // Hero section "לתשלום" button - direct checkout
    const heroCheckoutBtn = document.querySelector('.hero-checkout-btn');
    if (heroCheckoutBtn) {
      heroCheckoutBtn.addEventListener('click', function() {
        // Use the selected color variant from the color selector
        const variantId = getSelectedVariantId();
        buyNowCheckout(variantId, this);
      });
    }
    
    // Special hover handling for navigation arrows to prevent layout shift
    [prevBtn, nextBtn].forEach(btn => {
      if (btn) {
        btn.addEventListener('mouseenter', function() {
          this.style.transform = 'translateY(-50%) scale(1.1)';
        });
        
        btn.addEventListener('mouseleave', function() {
          this.style.transform = 'translateY(-50%) scale(1)';
        });
        
        btn.addEventListener('mousedown', function() {
          this.style.transform = 'translateY(-50%) scale(0.95)';
        });
        
        btn.addEventListener('mouseup', function() {
          this.style.transform = 'translateY(-50%) scale(1.1)';
        });
      }
    });
  });

  // Add CSS for gallery functionality
  const style = document.createElement('style');
  style.textContent = `
    @keyframes ripple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
    
    /* Gallery Custom Styles */
    .scrollbar-hide {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    .scrollbar-hide::-webkit-scrollbar {
      display: none;
    }
    
    .mobile-thumb {
      flex-shrink: 0;
      aspect-ratio: 4/3;
    }
    
    #main-image-container {
      position: relative;
      overflow: hidden;
    }
    
    #product-main-image {
      transition: transform 0.3s ease, opacity 0.3s ease;
    }
    
    .group:hover #prev-image,
    .group:hover #next-image {
      opacity: 1;
    }
    
    #zoom-overlay {
      backdrop-filter: blur(2px);
    }
    
    @media (max-width: 1024px) {
      #mobile-thumbnails {
        margin-top: 1rem;
        padding-bottom: 0.5rem;
      }
      
      /* Mobile-specific gallery styles */
      
      /* Ensure main image container takes full width on mobile */
      .w-full.lg\\:min-w-1\\/2 {
        width: 100% !important;
        max-width: none !important;
      }
      
      /* Make sure navigation arrows are always visible and properly sized on mobile */
      #prev-image, #next-image {
        opacity: 1 !important;
        padding: 8px;
        background: rgba(255, 255, 255, 0.9);
      }
      
      /* Ensure thumbnails are properly sized on mobile */
      .mobile-thumb {
        min-width: 70px;
        height: 70px;
        border-radius: 8px;
      }
    }
    
    /* Ensure good spacing and layout on all devices */
    @media (max-width: 768px) {    
      .mobile-thumb {
        min-width: 60px;
        height: 60px;
      }
    }
  `;
  document.head.appendChild(style);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lora-product"] && !Shopify.designMode) return;
  try {
    
  function scrollToProduct() {
    document.getElementById('product').scrollIntoView({ behavior: 'smooth' });
  }

  function scrollToFeatures() {
    document.getElementById('features').scrollIntoView({ behavior: 'smooth' });
  }
  
  // Initialize Glowing Up Close 3D viewer
  document.addEventListener('DOMContentLoaded', function() {
    const blockId = 'glowing_3d_viewer';
    const canvasId = 'canvas-' + blockId;
    const loadingId = 'loading-' + blockId;
    const viewerContainer = document.querySelector(`[data-block-id="${blockId}"]`);
    
    if (!viewerContainer) return;
    
    const initialColor = viewerContainer.dataset.modelColor || 'white';
    const autoRotate = viewerContainer.dataset.autoRotate === 'true';
    
    let scene, camera, renderer, controls, model;
    let lightEmittingMesh = null;
    let isLightOn = false;
    let originalMaterial = null;
    let pivotGroup = null;
    let isAnimating = false;
    let spinningInterval = null;
    let currentMode = null;

    // Model configuration for different colors
    const modelConfig = {
      'black': {
        file: viewerContainer.dataset.blackModel,
        headGroup: { indices: [1, 2, 5, 7], names: [] },
        lightMesh: { index: 7, name: null }
      },
      'white': {
        file: viewerContainer.dataset.whiteModel,
        headGroup: { indices: [1, 2, 6, 9], names: [] },
        lightMesh: { index: 9, name: null }
      },
      'pink': {
        file: viewerContainer.dataset.pinkModel,
        headGroup: { indices: [1, 2, 5, 6], names: [] },
        lightMesh: { index: 6, name: null }
      }
    };
    
    // Wait for Three.js to be available
    function waitForThreeJS(callback) {
      if (typeof THREE !== 'undefined' && typeof GLTFLoader !== 'undefined' && typeof OrbitControls !== 'undefined') {
        callback();
        } else {
        setTimeout(() => waitForThreeJS(callback), 100);
      }
    }
    
    function init() {
      const canvas = document.getElementById(canvasId);
      if (!canvas) return;
      
      // Scene setup
      scene = new THREE.Scene();
      
      // Camera setup
      const container = canvas.parentElement;
      const aspect = container.offsetWidth / container.offsetHeight;
      camera = new THREE.PerspectiveCamera(75, aspect, 0.1, 500);
      camera.position.set(0, 1, 2.5);
      
      // Renderer setup
      renderer = new THREE.WebGLRenderer({ 
        canvas: canvas,
        antialias: true, 
        alpha: true 
      });
      renderer.setSize(container.offsetWidth, container.offsetHeight);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      
      // Lighting
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      scene.add(ambientLight);
      
      const directionalLight = new THREE.DirectionalLight(0xffffff, 10);
      directionalLight.position.set(5, 10, 5);
      directionalLight.castShadow = true;
      directionalLight.shadow.mapSize.width = 2048;
      directionalLight.shadow.mapSize.height = 2048;
      scene.add(directionalLight);
      
      const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
      directionalLight2.position.set(-5, 5, -5);
      scene.add(directionalLight2);
      
      // Controls
      controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.dampingFactor = 0.05;
      controls.minDistance = 1.5;
      controls.maxDistance = 8;
      controls.autoRotate = false;
      controls.autoRotateSpeed = 0;
      controls.enableZoom = true;
      
      // Disable 3D controls on mobile/tablet
      const isMobile = window.innerWidth < 1024;
      if (isMobile) {
        controls.enabled = false;
        renderer.domElement.style.touchAction = 'auto';
        renderer.domElement.style.pointerEvents = 'none';
      }
      
      // Expose camera and controls to scene for external access
      scene.userData.camera = camera;
      scene.userData.controls = controls;
      
      // Load initial model
      loadModel(initialColor);
      
      // Handle resize
      window.addEventListener('resize', onWindowResize);
      
      // Start animation loop
      animate();
    }
    
    function loadModel(color) {
      const config = modelConfig[color];
      if (!config) {
        hideLoading();
        return;
      }
      
      // Remove existing model
      if (model) {
        scene.remove(model);
        model = null;
      }
      
      // Reset states
      lightEmittingMesh = null;
      isLightOn = false;
      originalMaterial = null;
      pivotGroup = null;
      
      // Load model
      const loader = new GLTFLoader();
      loader.load(
        config.file,
        function (gltf) {
          model = gltf.scene;
          
          // Center and scale model
          const box = new THREE.Box3().setFromObject(model);
          const center = box.getCenter(new THREE.Vector3());
          model.position.sub(center);
          model.scale.set(100, 100, 100);
          
          // Configure head group and light mesh
          setupModelInteractions(model, config);
          
          // Add to scene
          scene.add(model);
          
          // Start idle animation
          startIdleAnimation(model);
          
          hideLoading();
        },
        function (xhr) {
          console.log((xhr.loaded / xhr.total * 100) + '% loaded');
        },
        function (error) {
          console.error('Error loading glowing model:', error);
          hideLoading();
        }
      );
    }
    
    function setupModelInteractions(model, config) {
      const headMeshes = [];
      let meshCount = 0;
      
      model.traverse((child) => {
        if (child.isMesh) {
          meshCount++;
          
          if (config.headGroup.indices.includes(meshCount)) {
            headMeshes.push(child);
          }
          
          if (config.lightMesh.index === meshCount) {
            lightEmittingMesh = child;
            originalMaterial = child.material.clone();
          }
        }
      });
      
      if (headMeshes.length > 0) {
        setupHeadGroup(model, headMeshes);
      }
    }
    
    function setupHeadGroup(model, headMeshes) {
      const headBox = new THREE.Box3();
      headMeshes.forEach(mesh => headBox.expandByObject(mesh));
      const headCenter = headBox.getCenter(new THREE.Vector3());
      
      pivotGroup = new THREE.Group();
      pivotGroup.position.copy(headCenter);
      
      const headGroup = new THREE.Group();
      
      headMeshes.forEach(mesh => {
        const worldMatrix = new THREE.Matrix4();
        mesh.updateMatrixWorld();
        worldMatrix.copy(mesh.matrixWorld);
        
        mesh.parent.remove(mesh);
        headGroup.add(mesh);
        
        mesh.position.setFromMatrixPosition(worldMatrix);
        mesh.quaternion.setFromRotationMatrix(worldMatrix);
      });
      
      headGroup.position.copy(headCenter).multiplyScalar(-1);
      pivotGroup.add(headGroup);
      model.add(pivotGroup);
    }
    
    function rotateHead() {
      if (!pivotGroup || isAnimating) return;
      
      isAnimating = true;
      
      const startRotation = pivotGroup.rotation.y;
      const targetRotation = startRotation + (Math.PI / 2);
      const duration = 1000;
      const startTime = Date.now();
      
      const animateRotation = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const easeProgress = progress < 0.5 
          ? 2 * progress * progress 
          : -1 + (4 - 2 * progress) * progress;
        
        pivotGroup.rotation.y = startRotation + (targetRotation - startRotation) * easeProgress;
        
        if (progress < 1) {
          requestAnimationFrame(animateRotation);
        } else {
          isAnimating = false;
        }
      };
      
      animateRotation();
    }
    
    function toggleLight(isOn) {
      if (!lightEmittingMesh) return;

      isLightOn = isOn !== undefined ? isOn : !isLightOn;

      if (isLightOn) {
        const emissiveMaterial = lightEmittingMesh.material.clone();
        emissiveMaterial.emissive = new THREE.Color(0xff0000);
        emissiveMaterial.emissiveIntensity = 1.5;
        lightEmittingMesh.material = emissiveMaterial;
        
        // Darken the scene
        const canvas = document.getElementById(canvasId);
        if (canvas && canvas.parentElement) {
          canvas.parentElement.style.transition = 'background-color 0.5s ease';
          canvas.parentElement.style.backgroundColor = '#1a1a1a';
        }
        
        // Show red overlay
        const overlay = document.getElementById('red-light-overlay-' + blockId);
        if (overlay) {
          overlay.classList.remove('opacity-0');
          overlay.classList.add('opacity-100');
        }
      } else {
        lightEmittingMesh.material = originalMaterial;
        
        // Restore light background
        const canvas = document.getElementById(canvasId);
        if (canvas && canvas.parentElement) {
          canvas.parentElement.style.backgroundColor = '#f5f5f0';
        }
        
        // Hide red overlay
        const overlay = document.getElementById('red-light-overlay-' + blockId);
        if (overlay) {
          overlay.classList.remove('opacity-100');
          overlay.classList.add('opacity-0');
        }
      }
    }
    
    function onWindowResize() {
      if (!camera || !renderer) return;
      
      const container = renderer.domElement.parentElement;
      const width = container.offsetWidth;
      const height = renderer.domElement.offsetHeight;
      
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
      renderer.setSize(width, height);
      
      // Re-check mobile status on resize and update controls
      const isMobile = window.innerWidth < 1024;
      if (controls) {
        if (isMobile) {
          controls.enabled = false;
          renderer.domElement.style.touchAction = 'auto';
          renderer.domElement.style.pointerEvents = 'none';
        } else {
          controls.enabled = true;
          renderer.domElement.style.touchAction = 'none';
          renderer.domElement.style.pointerEvents = 'auto';
        }
      }
    }
    
    function hideLoading() {
      const loadingOverlay = document.getElementById(loadingId);
      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
      }
    }
    
    function animate() {
      requestAnimationFrame(animate);
      
      if (controls) {
        controls.update();
      }
      
      if (renderer && scene && camera) {
        renderer.render(scene, camera);
      }
    }
    
    function startIdleAnimation(model) {
      // Idle animation disabled for glowing viewer to prevent constant movement
      if (!model) return;
      
      // Keep model stationary at its original position
      // No floating animation for better 3D control experience
    }

    // Continuous spinning functions
    function startContinuousSpinning() {
      if (!pivotGroup || spinningInterval) return;
      
      // Rotate head every 2 seconds
      spinningInterval = setInterval(() => {
        if (!isAnimating) {
          rotateHead();
        }
      }, 2000);
    }
    
    function stopContinuousSpinning() {
      if (spinningInterval) {
        clearInterval(spinningInterval);
        spinningInterval = null;
      }
    }

    // Expose functions for external control
    window[`viewer_${blockId}`] = {
      loadModel: loadModel,
      rotateHead: rotateHead,
      startContinuousSpinning: startContinuousSpinning,
      stopContinuousSpinning: stopContinuousSpinning,
      toggleLight: toggleLight,
      getModel: () => model,
      getScene: () => scene,
      // Helper functions for recording positions
      getCurrentCameraPosition: () => {
        if (!camera || !controls) return null;
        return {
          position: {
            x: camera.position.x,
            y: camera.position.y,
            z: camera.position.z
          },
          target: {
            x: controls.target.x,
            y: controls.target.y,
            z: controls.target.z
          }
        };
      },
      setCameraPosition: (position, target) => {
        if (!camera || !controls) return;
        if (position) {
          camera.position.set(position.x, position.y, position.z);
        }
        if (target) {
          controls.target.set(target.x, target.y, target.z);
        }
        controls.update();
      },
      focusOnFeature: (targetName) => {
        focusOnFeature(targetName);
      }
    };
    
    // Initialize when Three.js is ready
    waitForThreeJS(init);
  });

    // Enhanced Apple-style interactions - Only for this section (no product selection)
  document.addEventListener('DOMContentLoaded', function() {
    // Enhanced button interactions for this section only
    const buttons = document.querySelectorAll('button');
    buttons.forEach(button => {
      // Skip buttons that are part of the product selection (handled in add-to-cart section)
      if (button.closest('#features')) return;
      
      button.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-2px)';
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
      });
      
      button.addEventListener('mousedown', function() {
        this.style.transform = 'translateY(0) scale(0.98)';
      });
      
      button.addEventListener('mouseup', function() {
        this.style.transform = 'translateY(-2px) scale(1)';
      });
    });

    // Intersection Observer for animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe feature cards
    const featureCards = document.querySelectorAll('.group');
    featureCards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    });

    // Smooth scroll for all internal links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  });

  // Initialize Glowing Up Close section functionality
  document.addEventListener('DOMContentLoaded', function() {
    const glowingViewer = 'glowing_3d_viewer';
    
    // Handle feature bullet interactions with new expanded class approach
    const featureBullets = document.querySelectorAll('.feature-bullet');
    
    featureBullets.forEach(bullet => {
      const bulletButton = bullet.querySelector('.bullet');
      const feature = bullet.dataset.feature;
      const target = bullet.dataset.target;
      
      if (!bulletButton) return;
      
      bulletButton.addEventListener('click', function() {
        // Close all other bullets first
        featureBullets.forEach(otherBullet => {
          if (otherBullet !== bullet) {
            otherBullet.classList.remove('expanded');
          }
        });
        
        // Toggle current bullet
        const isExpanded = bullet.classList.contains('expanded');
        
        if (!isExpanded) {
          // Expand current bullet
          bullet.classList.add('expanded');
          
          // Focus 3D model on feature
          focusOnFeature(target);
          
          // Handle color selection for Colors feature
          if (feature === 'colors') {
            setupColorSelection();
          }
        } else {
          // Collapse current bullet
          bullet.classList.remove('expanded');
        }
      });
    });
    
    function focusOnFeature(target) {
      const viewer3D = window[`viewer_${glowingViewer}`];
      if (!viewer3D || !viewer3D.getScene || !viewer3D.getModel) return;
      
      const model = viewer3D.getModel();
      if (!model) return;
      
      // Stop any existing continuous spinning when switching modes
      viewer3D.toggleLight(false);
      if (viewer3D.stopContinuousSpinning) {
        viewer3D.stopContinuousSpinning();
      }
      
      // Camera focusing logic based on target
      switch(target) {
        case 'colors':
          // Focus on full model for color showcase
          focusCamera(0, 1, 2.5, 0, 0, 0);
          break;
        case 'body':
          // Focus on main body for stainless steel
          focusCamera(-1.52, 1.19, 0.83, -0.78, 0.15, 0.05);
          break;
        case 'charging':
          // Focus on bottom/charging area
          focusCamera(2.53, -0.05, -0.02, 1.04, -0.17, 0.08);
          break;
        case 'spinning':
          // Focus on head area and start continuous spinning
          focusCamera(-2.5, 2, 0, 0, 0, 0);
          viewer3D.rotateHead();
          // Start continuous rotation every 2 seconds
          if (viewer3D.startContinuousSpinning) {
            viewer3D.startContinuousSpinning();
          }
          else {
            console.log('continuous spinning isn\'t available');
          }
          break;
        case 'led':
          // Close up on LED light area
          focusCamera(-1.52, 1.19, 0.83, -0.78, 0.15, 0.05);
          // Turn on the LED light
          if (viewer3D.toggleLight) {
            viewer3D.toggleLight();
          }
          break;
        case 'buttons':
          // Focus on control buttons area
          focusCamera(2, 2, 0, 0, 0, 0);
          break;
        default:
          // Default view
          focusCamera(0, 1, 2.5, 0, 0, 0);
      }
    }
    
    function focusCamera(posX, posY, posZ, targetX, targetY, targetZ) {
      const viewer3D = window[`viewer_${glowingViewer}`];
      if (!viewer3D || !viewer3D.getScene) return;
      
      // Get camera from the viewer (we'll need to expose it)
      const scene = viewer3D.getScene();
      if (!scene) return;
      
      // Smooth camera animation
      const camera = scene.userData.camera;
      const controls = scene.userData.controls;
      
      if (camera && controls) {
        // Animate camera position
        const startPos = camera.position.clone();
        const endPos = new THREE.Vector3(posX, posY, posZ);
        const startTarget = controls.target.clone();
        const endTarget = new THREE.Vector3(targetX, targetY, targetZ);
        
        const duration = 1500; // 1.5 seconds
        const startTime = Date.now();
        
        const animateCamera = () => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeProgress = 1 - Math.pow(1 - progress, 3); // ease-out-cubic
          
          camera.position.lerpVectors(startPos, endPos, easeProgress);
          controls.target.lerpVectors(startTarget, endTarget, easeProgress);
          controls.update();
          
          if (progress < 1) {
            requestAnimationFrame(animateCamera);
          }
        };
        
        animateCamera();
      }
    }
    
    function setupColorSelection() {
      const colorOptions = document.querySelectorAll('.color-option-detail');
      
      colorOptions.forEach(option => {
        option.addEventListener('click', function() {
          const color = this.dataset.color;
          
          // Remove active state from all options
          colorOptions.forEach(opt => opt.classList.remove('bg-stone-300'));
          
          // Add active state to selected option
          this.classList.add('bg-stone-300');
          
          // Change 3D model color
          const viewer3D = window[`viewer_${glowingViewer}`];
          if (viewer3D && viewer3D.loadModel) {
            viewer3D.loadModel(color);
          }
          
          // Also update main hero viewer if available
          const heroViewer = window.viewer_hero_3d_viewer;
          if (heroViewer && heroViewer.loadModel) {
            heroViewer.loadModel(color);
            
            // Update color selector UI in hero section
            const heroColorOptions = document.querySelectorAll('#color-selector .color-option');
            heroColorOptions.forEach(opt => opt.classList.remove('active'));
            
            const targetHeroOption = document.querySelector(`#color-selector [data-color="${color}"]`);
            if (targetHeroOption) {
              targetHeroOption.classList.add('active');
            }
          }
        });
      });
    }
  });

  // Add CSS for ripple animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes ripple {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

  // Simple function to get current 3D camera position - use in browser console
  window.getCameraPosition = function() {
    const viewer = window.viewer_glowing_3d_viewer;
    
    if (!viewer) {
      console.error('Glowing 3D viewer not loaded yet. Try again in a few seconds or scroll to the "Glowing, also Up Close" section.');
      return;
    }
    
    if (!viewer.getCurrentCameraPosition) {
      console.error('Camera position function not available');
      return;
    }
    
    const position = viewer.getCurrentCameraPosition();
    if (position) {
      console.log(`focusCamera(${position.position.x.toFixed(2)}, ${position.position.y.toFixed(2)}, ${position.position.z.toFixed(2)}, ${position.target.x.toFixed(2)}, ${position.target.y.toFixed(2)}, ${position.target.z.toFixed(2)});`);
      console.log(`Position: x=${position.position.x.toFixed(2)}, y=${position.position.y.toFixed(2)}, z=${position.position.z.toFixed(2)}`);
      console.log(`Target: x=${position.target.x.toFixed(2)}, y=${position.target.y.toFixed(2)}, z=${position.target.z.toFixed(2)}`);
      return position;
    } else {
      console.error('Could not get camera position - make sure the 3D model is loaded');
    }
  };
  
  // Alternative function to check if viewer is ready
  window.checkViewer = function() {
    const viewer = window.viewer_glowing_3d_viewer;
    if (viewer) {
      console.log('✅ Glowing 3D viewer is loaded and ready');
      console.log('Available functions:', Object.keys(viewer));
      return true;
    } else {
      console.log('❌ Glowing 3D viewer not loaded yet');
      return false;
    }
  };

  // Enhanced hero image animation with 3D perspective warp
  document.addEventListener('DOMContentLoaded', function() {
    const heroImage = document.querySelector('.hero-image');
    if (heroImage) {
      // Trigger 3D perspective animation after a short delay
      setTimeout(() => {
        // Remove initial opacity and transform, add final state
        heroImage.classList.remove('opacity-0', 'translate-y-8');
        heroImage.classList.add('opacity-100', 'translate-y-0');
        
        // Animate from -30deg angle to flat (0deg) with scale, opacity, and contrast
        heroImage.style.transform = 'rotateX(0deg) translateY(0) scale(1)';
        heroImage.style.opacity = '1';
        heroImage.style.filter = 'contrast(1)';
      }, 300);
    }
  });

  // Scroll-based rotation animation for lora-hd-body.png
  document.addEventListener('DOMContentLoaded', function() {
    const rotatingImage = document.getElementById('rotating-lora-body');
    if (!rotatingImage) return;
    
    // Get the section containing the rotating image
    const rotatingSection = rotatingImage.closest('section');
    if (!rotatingSection) return;
    
    function updateRotation() {
      const rect = rotatingSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Only animate when section is actually visible on screen
      if (rect.bottom < 0 || rect.top > windowHeight) {
        return; // Section not visible, don't animate
      }

      // Calculate progress based on section visibility in viewport
      // Animation starts immediately when section appears and completes when section exits
      const sectionHeight = rect.height;
      
      // Simple, consistent progress calculation
      // Animation starts when section enters viewport and ends when it fully exits
      let progress = 0;
      
      if (rect.top <= windowHeight && rect.bottom >= 0) {
        // Section is visible - calculate smooth progress
        const totalScrollDistance = sectionHeight + windowHeight;
        const currentScroll = windowHeight - rect.top;
        progress = Math.min(1, Math.max(0, currentScroll / totalScrollDistance));
      } else if (rect.bottom < 0) {
        // Section has fully scrolled past - animation complete
        progress = 1;
      }
      // If rect.top > windowHeight, section hasn't entered yet, progress stays 0
      
      // Apply smooth easing - ease-out-cubic for natural deceleration
      const easedProgress = progress < 0.5 
        ? 2 * progress * progress 
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      
      // Calculate rotation: 90deg to -90deg with easing
      const startRotation = 90;
      const endRotation = -90;
      const rotation = startRotation + (easedProgress * (endRotation - startRotation));
      
      // Apply rotation while preserving original transform properties (translateY(-50%))
      rotatingImage.style.transform = `translateY(-50%) rotate(${rotation}deg)`;
    }
    
    // Listen to scroll events with throttling for better performance
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateRotation();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    // Attach scroll listener
    window.addEventListener('scroll', onScroll);
    
    // Initial calculation
    updateRotation();
  });


  } catch(e) { console.error(e); }
})();
})();
